import React from "react"
import styled from "styled-components"

// Styling
import { fontWeights } from "../../../styles/textStyles"
import colors from "../../../styles/colors"

interface IProps {
  label: string
}

const Label: React.FCS<IProps> = ({ label, className }) => (
  <Container className={className}>{label}</Container>
)

const Container = styled.label`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -1%;
  font-weight: ${fontWeights.regular};
  margin-bottom: 4px;
  color: ${colors.main["300"]};
`

export default Label
